import axios, { config } from "./mydefaults";
import { createApp } from "vue";

import BookingForm from "./components/BookingForm.vue";
import FloatingLabel from './components/FloatingLabel.vue';
import { reference } from "@popperjs/core";

const bookingApp = createApp({
    data() {
        return {
            scheduleList:[],
            charterList:[],
            desList:[],
            countries:[],
            selectedOrigin:null,
            selectedDest:null,
            charterOrigin:null,
            charterDest:null,
            reference:'',
            isloading:false,
        };
    },
    components: {
        BookingForm,
        FloatingLabel,
    },
    computed:{
        filteredDestinations(){
            if (!this.charterOrigin) return []
            return this.charterList.filter(c => c.code !== this.charterOrigin)
        }
    },
    watch:{
        selectedOrigin :{
            handler: function (val, oldVal) {
                const vm = this;
                if(val !=null){
                    axios
                        .get(`${appbaseurl}data/destinations?country=${val}`)
                        .then((response) => {
                            console.log("destinations", response);
                            vm.desList = response.data;
                        })
                        .catch((err) => console.log(err));
                }else{
                    this.selectedDest = null;
                    this.desList =[];
                }
               
            }
        },
        selectedDest :{
            handler: function (val, oldVal) {
                const vm = this;
                if(val !=null){
                    //this.isloading =true;
                }else{
                    
                }
               
            }
        },
    },
    mounted() {
        if( window.origin.code){
            const origin = window.origin;
            this.selectedOrigin = origin.code;
        }
        axios
            .get(`${appbaseurl}bookingdata`)
            .then((response) => {
                console.log("fees", response);
                this.scheduleList = response.data.schedules;
                this.charterList = response.data.charters;
            })
            .catch((err) => console.log(err));
    },
    methods: {

    },
});

bookingApp.mount("#booking-app");
